import omit from 'lodash/omit';

export function allIds(state, action) {
  const { containerIds } = action.payload;
  const newList = state.filter(givenId => containerIds.indexOf(givenId) === -1);
  return [...newList];
}

export function byId(state, action) {
  const { containerIds } = action.payload;
  let newState = { ...state };

  containerIds.forEach((givenId) => {
    newState = omit(newState, givenId);
  });

  return { ...newState };
}
